import React from "react";
import PropTypes from "prop-types";

const ExportButton = ({ onClick }) => (
  <button className="btn btn-outline-primary" onClick={onClick} type="button">
    <i className="feather-download me-2" />
    Exportar CSV
  </button>
);

ExportButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ExportButton;
